import { useState, useEffect } from "react";
import { Card, Col, Form, Row } from "react-bootstrap";

import { toast } from "react-hot-toast";
import Progress from "react-progress-2";
import CardHeader from "../../components/common/CardHeader";
import LinkButton from "../../components/common/LinkButton";
import CardBody from "../../components/common/CardBody";
import EditButton from "../../components/common/EditButton";
import ViewButton from "../../components/common/ViewButton";
import DeleteButton from "../../components/common/DeleteButton";
import ProductImage from "../../components/common/ProductImage";
import CheckPermission from "../../components/roles/CheckPermission";
import { privateApi } from "../../api";

const AssociationCategoryList = () => {
      const [loading, setLoading] = useState(false);
      const [types, setCategories] = useState([]);
      const [totalCategory, setTotalCategory] = useState(0);
      const [perPages, setPerPages] = useState(0);
      const [currentPage, setCurrentPage] = useState(0);

      const [limit, setLimit] = useState(10);

      const loadData = async () => {
            setLoading(true);
            await privateApi(`/dashboard/association_categories?limit=${limit}`)
                  .then((response) => {
                        if (response.data.result === "success") {
                              setCategories(response.data.categories);
                              setTotalCategory(response.data.totalCategory);
                              setPerPages(response.data.itemsCountPerPage);
                              setCurrentPage(response.data.currentPage);
                        }
                  })
                  .catch((error) => {
                        toast.error(error.message);
                  });
            setLoading(false);
      };
      useEffect(() => {
            loadData();
      }, [limit]);

      async function getData(pageNumber = 1) {
            window.scrollTo(0, 0);
            Progress.show();
            const url = `/dashboard/association_categories?page=${pageNumber}`;
            await privateApi(url)
                  .then((response) => {
                        setCategories(response.data.types);
                        setTotalCategory(response.data.totalCategory);
                        setPerPages(response.data.itemsCountPerPage);
                        setCurrentPage(response.data.currentPage);
                        Progress.hide();
                  })
                  .catch((error) => {
                        toast.error(error.message);
                  });
      }

      const handleDelete = async (type) => {
            const response = await privateApi
                  .delete(`/dashboard/association_categories/${type.slug}`)
                  .then((response) => {
                        if (response.data.result === "success") {
                              setCategories((types) =>
                                    types.filter((item) => item.id !== type.id)
                              );
                              loadData();
                              toast.success(response.data.message);
                              return true;
                        }
                  })
                  .catch((error) => {
                        toast.error(error.message);
                  });
            return response;
      };

      const handleStatus = async (type) => {
            await privateApi
                  .post(`/dashboard/association_categories/${type.slug}/status`)
                  .then((response) => {
                        if (response.data.result === "success") {
                              toast.success(response.data.message);
                        }
                        if (response.data.result === "error") {
                              toast.error(response.data.message);
                        }
                  })
                  .catch((error) => {
                        toast.error(error.message);
                  });
      };

      return (
            <>
                  <Row>
                        <Col lg={12}>
                              <Card>
                                    <CardHeader title="Category List">
                                          <LinkButton
                                                link="/dashboard/association_categories/create"
                                                title="Add New"
                                          />
                                    </CardHeader>
                                    <CardBody
                                          setLimit={setLimit}
                                          perPages={perPages}
                                          totalItems={totalCategory}
                                          currentPage={currentPage}
                                          getData={getData}
                                          setSearch={setSearch}
                                    >
                                          <thead>
                                                <tr>
                                                      <th
                                                            className="text-center"
                                                            width="80px"
                                                      >
                                                            #
                                                      </th>
                                                      <th>Title</th>
                                                      <th width="120px">
                                                            Date
                                                      </th>
                                                      <th width="120px">
                                                            Status
                                                      </th>
                                                      <th width="120px">
                                                            Action
                                                      </th>
                                                </tr>
                                          </thead>
                                          <tbody>
                                                {!loading ? (
                                                      types.length > 0 ? (
                                                            types.map(
                                                                  (
                                                                        type,
                                                                        index
                                                                  ) => (
                                                                        <>
                                                                              <tr
                                                                                    key={
                                                                                          index
                                                                                    }
                                                                              >
                                                                                    <td className="text-center">
                                                                                          {
                                                                                                type.index
                                                                                          }
                                                                                    </td>
                                                                                    <td>
                                                                                          <ProductImage
                                                                                                title={
                                                                                                      type.title
                                                                                                }
                                                                                                category={`By: ${type.user_name}`}
                                                                                          />
                                                                                    </td>
                                                                                    <td>
                                                                                          {
                                                                                                type.date
                                                                                          }
                                                                                    </td>
                                                                                    <td>
                                                                                          <Form.Check
                                                                                                type="switch"
                                                                                                id="custom-switch"
                                                                                                defaultChecked={
                                                                                                      type.status ===
                                                                                                      1
                                                                                                            ? true
                                                                                                            : false
                                                                                                }
                                                                                                onClick={() =>
                                                                                                      handleStatus(
                                                                                                            type
                                                                                                      )
                                                                                                }
                                                                                          />
                                                                                    </td>
                                                                                    <td className="text-center">
                                                                                          <EditButton
                                                                                                link={`/dashboard/association_categories/${type.slug}/edit`}
                                                                                          />
                                                                                          <ViewButton
                                                                                                link={`/dashboard/association_categories/${type.slug}/show`}
                                                                                          />
                                                                                          <CheckPermission permission="association-delete">
                                                                                                <DeleteButton
                                                                                                      item={
                                                                                                            type
                                                                                                      }
                                                                                                      loading={
                                                                                                            loading
                                                                                                      }
                                                                                                      setLoading={
                                                                                                            setLoading
                                                                                                      }
                                                                                                      handleDelete={
                                                                                                            handleDelete
                                                                                                      }
                                                                                                />
                                                                                          </CheckPermission>
                                                                                    </td>
                                                                              </tr>
                                                                        </>
                                                                  )
                                                            )
                                                      ) : (
                                                            <>
                                                                  <tr>
                                                                        <td
                                                                              colSpan="5"
                                                                              className="text-center"
                                                                        >
                                                                              No
                                                                              Category
                                                                              Found.
                                                                        </td>
                                                                  </tr>
                                                            </>
                                                      )
                                                ) : (
                                                      <>
                                                            <tr>
                                                                  <td
                                                                        colSpan="5"
                                                                        className="text-center"
                                                                  >
                                                                        Loading...
                                                                  </td>
                                                            </tr>
                                                      </>
                                                )}
                                          </tbody>
                                    </CardBody>
                              </Card>
                        </Col>
                  </Row>
            </>
      );
};

export default AssociationCategoryList;
